<template>
  <div class="qna" v-if="question.q">
    <div
      style="min-height: 64px"
      class="vertical-center"
      v-on:click="expandAnswer(idx)"
    >
      <div class="q">
        <div class="title">
          <span class="icon">
            <i
              class="fal fa-question-circle"
              :class="{ select: selectIdx === idx }"
            />
          </span>
          <div :class="{ bold: selectIdx === idx }">{{ question.title }}</div>
        </div>
        <div class="icon-expand">
          <img
            :class="{ rotate: selectIdx !== idx }"
            src="@/assets/img/ic_arrow_gray_down.svg"
          />
        </div>
      </div>
    </div>
    <div class="a" v-if="selectIdx === idx">
      <span>{{ question.content }}</span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    expandAnswer(idx) {
      this.$emit("expandQuestion", idx);
    },
  },
  props: ["idx", "question", "selectIdx"],
};
</script>

<style src="./list.css" scoped />
